module.exports = __webpack_public_path__ + "static/media/Professor_Teas.f47c7ee7.md";